export enum ShopActEnum {
  INFORMATION = "@shop/INFORMATION",
  DESCRIPTOR = "@shop/DESCRIPTOR",
  LOGIN_AGAIN = "@shop/LOGIN_AGAIN"
}
